/* Hollow Street Streetlab: hover depth, accessible motion fallback. Purchase flow lives in Shopify product data. */
(()=>{'use strict';
const reduced=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
const fine=window.matchMedia?.('(hover:hover) and (pointer:fine)').matches;
const hero=document.querySelector('[data-street-hero]');
if(hero && !reduced && fine){
 const monument=hero.querySelector('.hs-street-monument');
 let pending=false,ax=0,ay=0;
 hero.addEventListener('pointermove',e=>{
  if(document.body.classList.contains('hs-motion-paused'))return;
  const r=hero.getBoundingClientRect();
  ax=((e.clientX-r.left)/r.width-.5)*7;
  ay=((e.clientY-r.top)/r.height-.5)*-5;
  if(pending)return;pending=true;
  requestAnimationFrame(()=>{monument.style.transform=`perspective(1100px) rotateY(${ax.toFixed(2)}deg) rotateX(${ay.toFixed(2)}deg)`;pending=false;});
 },{passive:true});
 hero.addEventListener('pointerleave',()=>{monument.style.transform='perspective(1100px) rotateY(0deg) rotateX(0deg)'});
}
if(!reduced&&fine){
 document.querySelectorAll('.hs-atelier-piece-button').forEach(card=>{
  let pending=false,rx=0,ry=0;
  card.addEventListener('pointermove',e=>{
   if(document.body.classList.contains('hs-motion-paused'))return;
   const r=card.getBoundingClientRect();
   rx=(((e.clientY-r.top)/r.height)-.5)*-4;
   ry=(((e.clientX-r.left)/r.width)-.5)*4;
   if(pending)return;pending=true;
   requestAnimationFrame(()=>{card.style.setProperty('--rx',rx.toFixed(2)+'deg');card.style.setProperty('--ry',ry.toFixed(2)+'deg');pending=false});
  },{passive:true});
  card.addEventListener('pointerleave',()=>{card.style.setProperty('--rx','0deg');card.style.setProperty('--ry','0deg')});
 });
}
})();
/* Motion is optional, suspended outside the viewport and when the tab is hidden. */
(()=>{'use strict';const reduced=matchMedia('(prefers-reduced-motion: reduce)');let paused=false;
function init(scope=document){scope.querySelectorAll('[data-motion-toggle]').forEach(b=>{if(b.dataset.ready)return;b.dataset.ready='true';b.addEventListener('click',()=>{paused=!paused;document.body.classList.toggle('hs-motion-paused',paused);b.setAttribute('aria-pressed',String(paused));b.textContent=paused?'RESUME MOTION':'PAUSE MOTION'})});if(!('IntersectionObserver'in window)||reduced.matches)return;
const reveal=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.remove('is-pending');reveal.unobserve(e.target)}}),{threshold:.08});scope.querySelectorAll('.hs-atelier-section-top,.hs-beanie-head,.hv-section-heading').forEach(x=>{x.classList.add('hs-reveal','is-pending');reveal.observe(x)});
const motion=new IntersectionObserver(entries=>entries.forEach(e=>e.target.classList.toggle('hs-offscreen',!e.isIntersecting)));scope.querySelectorAll('[data-street-hero]').forEach(x=>motion.observe(x));}
document.addEventListener('visibilitychange',()=>document.body.classList.toggle('hs-motion-paused',document.hidden||paused));init();document.addEventListener('shopify:section:load',e=>init(e.target));})();
